<template>
  <div class="express-page">
    <header class="site-header">
      <div class="header-inner">
        <img src="../assets/logo.png" alt="U盾商城" class="logo" @click="toHome" />
        <nav class="nav-pc">
          <span class="nav-link" @click="toHome">首页</span>
          <span class="nav-link">查找订单</span>
          <span class="nav-link nav-member">
            会员中心
            <down-outlined class="nav-arrow" />
          </span>
        </nav>
        <button type="button" class="nav-mobile" aria-label="菜单" @click="menuOpen = !menuOpen">
          <span /><span /><span />
        </button>
      </div>
      <div v-if="menuOpen" class="mobile-menu">
        <span @click="toHome">首页</span>
        <span>查找订单</span>
        <span>会员中心</span>
      </div>
    </header>

    <main class="main">
      <div class="container">
        <p class="breadcrumb">
          <span class="link" @click="toHome">网站首页</span>
          <span class="sep">——</span>
          <span>未联系客服前勿拍本商品</span>
          <span class="sep">——</span>
          <span>【补差价专用链接】请根据客服沟通指引下单，请勿乱拍</span>
        </p>

        <div class="layout">
          <div class="col-left">
            <div class="card product-card">
              <div class="product-media">
                <div v-if="detail.src" class="info-icon-wrap">
                  <img :src="detail.src" alt="" class="info-icon product-cover" />
                </div>
                <div v-else class="info-icon-wrap">
                  <img src="../assets/desc.png" alt="" class="info-icon" />
                </div>
              </div>
              <div class="product-body">
                <h1 class="product-title">{{ detail.title }}</h1>

                <div class="tag-row mobile-only">
                  <span class="tag tag-blue">{{ detail.sendWay }}</span>
                  <span class="tag tag-red">库存 {{ detail.count }}</span>
                  <span class="tag tag-gold">销量 {{ detail.sell }}</span>
                </div>

                <div class="qty-row">
                  <span class="label">购买数量：</span>
                  <div class="qty-stepper">
                    <button type="button" class="qty-btn" :disabled="inputNumber <= 1" @click="inputNumber--">
                      <minus-outlined />
                    </button>
                    <input
                      v-model.number="inputNumber"
                      class="qty-input"
                      type="text"
                      maxlength="6"
                      @input="onQtyInput"
                    />
                    <button type="button" class="qty-btn" @click="inputNumber++">
                      <plus-outlined />
                    </button>
                  </div>
                </div>

                <div class="pay-row">
                  <p class="pay-label">选择支付方式</p>
                  <div class="pay-btn">
                    <img src="../assets/pay-way.png" alt="" class="pay-icon" />
                    <span>USDT 网关支付</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="card desc-card pc-desc">
              <div class="desc-head">
                <img src="../assets/desc.png" alt="" class="desc-icon" />
                <span>商品描述</span>
              </div>
              <div class="desc-body">{{ detail.detail || '' }}</div>
            </div>
          </div>

          <div class="col-right">
            <div class="card order-card">
              <p class="price">${{ displayPrice }}</p>
              <p class="form-title">下单TG</p>
              <a-input v-model:value="form.tg" class="form-input" placeholder="请输入TG" />
              <p class="form-tip">
                游客购买后，查询订单信息需要用到 查单密码。登录用户无需填写此项
              </p>
              <button type="button" class="buy-btn" @click="onBuy">
                <img src="../assets/car.png" alt="" class="buy-icon" />
                立即购买
              </button>
              <div class="contact-box">
                <img src="../assets/gift.png" alt="" class="contact-icon" />
                <span>遇到任何问题，请及时联系网站客服</span>
              </div>
            </div>

            <div class="card sales-card pc-only">
              <p class="sales-title">销售信息</p>
              <div class="sales-row">
                <div class="sales-icon-wrap">
                  <img src="../assets/count.png" alt="" />
                </div>
                <div class="sales-text">
                  <span class="sales-label">库存剩余</span>
                  <span class="sales-value">{{ detail.count }}</span>
                </div>
              </div>
              <div class="sales-row">
                <div class="sales-icon-wrap">
                  <img src="../assets/sell.png" alt="" />
                </div>
                <div class="sales-text">
                  <span class="sales-label">总销量</span>
                  <span class="sales-value">{{ detail.sell }}</span>
                </div>
              </div>
              <div class="sales-row">
                <div class="sales-icon-wrap">
                  <img src="../assets/send-way.png" alt="" />
                </div>
                <div class="sales-text">
                  <span class="sales-label">发货方式</span>
                  <span class="sales-value">{{ detail.sendWay }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card desc-card mobile-desc">
          <div class="desc-head">
            <img src="../assets/desc.png" alt="" class="desc-icon" />
            <span>商品描述</span>
          </div>
          <div class="desc-body desc-body-empty" />
        </div>
      </div>
    </main>

    <footer class="site-footer">
      <div class="footer-inner">
        <span class="beian">备案号</span>
        <span class="copyright">U盾商城 - 保留所有解释权。</span>
      </div>
    </footer>
  </div>
</template>

<script>
import { DownOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons-vue';
import { addOrder } from '../util/api';
import { initSpecialProductPage, resolveLinkKey } from '../util/specialProduct';

const DEFAULT_PRODUCT = {
  title: '信息登记',
  sendWay: '自动发货',
  count: 999,
  sell: 999,
  price: 0.1,
};

export default {
  name: 'ExpressDelivery',
  components: {
    DownOutlined,
    PlusOutlined,
    MinusOutlined,
  },
  data() {
    return {
      menuOpen: false,
      referralCode: '',
      inputNumber: 1,
      form: {
        tg: '',
      },
      detail: { ...DEFAULT_PRODUCT },
      specialProduct: null,
    };
  },
  computed: {
    displayPrice() {
      const p = Number(this.detail.price) || 0;
      if (p % 1 === 0) return ` ${p}`;
      const s = p.toFixed(2);
      return s.endsWith('0') ? ` ${p.toFixed(1)}` : ` ${s}`;
    },
  },
  async mounted() {
    const params = new URLSearchParams(window.location.search);
    this.referralCode = params.get('code') || '';

    if (this.$route.params.data) {
      try {
        const data = JSON.parse(this.$route.params.data);
        this.detail = { ...DEFAULT_PRODUCT, ...data };
        if (data.referral_code) {
          this.referralCode = data.referral_code;
        }
      } catch (e) {
        console.warn('parse route data failed', e);
      }
      return;
    }

    const linkKey = resolveLinkKey(this.$route) || 'express';
    await initSpecialProductPage(this, linkKey, {
      detailField: 'detail',
      fallback: {
        ...DEFAULT_PRODUCT,
        title: linkKey === 'register' ? '登记信息专用' : '实物快递',
      },
    });
  },
  methods: {
    onQtyInput(e) {
      const v = String(e.target.value).replace(/\D/g, '');
      this.inputNumber = v ? Math.max(1, parseInt(v, 10)) : 1;
    },
    toHome() {
      const q = this.referralCode ? `?code=${this.referralCode}` : '';
      this.$router.push('/' + q);
    },
    getCurrentDateTime() {
      const date = new Date();
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}${m}${d}${h}${min}${s}`;
    },
    async onBuy() {
      const tg = (this.form.tg || '').trim();

      const payload = {
        ...this.detail,
        referral_code: this.referralCode,
        inputNumber: this.inputNumber,
        receiveQty: String(this.inputNumber),
        tgAccount: tg,
        inputGT: tg,
        orderNo:
          this.getCurrentDateTime() +
          Math.floor(Math.random() * 100000)
            .toString()
            .padStart(6, '0'),
        src: '',
      };

      await addOrder(payload);
      this.$router.push({
        name: 'ExpressPayment',
        params: { data: JSON.stringify(payload) },
      });
    },
  },
};
</script>

<style scoped lang="less">
@blue: #1890ff;
@blue-dark: #1677ff;
@bg-top: #c8e4f8;
@bg-bottom: #e8f4fc;
@text-muted: #666;
@warn-red: #e7473c;
@card-radius: 10px;
@shadow: 0 4px 16px rgba(100, 150, 200, 0.18);

.express-page {
  min-height: 100vh;
  background: linear-gradient(180deg, @bg-top 0%, @bg-bottom 35%, #f0f7fc 100%);
  display: flex;
  flex-direction: column;
}

/* Header */
.site-header {
  background: #fff;
  border-bottom: 1px solid #edf2fa;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  height: 40px;
  width: auto;
  cursor: pointer;
}

.nav-pc {
  display: flex;
  align-items: center;
  gap: 36px;
  font-size: 16px;
  color: #333;

  .nav-link {
    cursor: pointer;
    line-height: 60px;

    &:hover {
      color: @blue;
    }
  }

  .nav-member {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .nav-arrow {
    font-size: 12px;
    color: #999;
  }
}

.nav-mobile {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 36px;
  height: 36px;
  padding: 6px;
  border: none;
  background: transparent;
  cursor: pointer;

  span {
    display: block;
    height: 2px;
    background: #666;
    border-radius: 1px;
  }
}

.mobile-menu {
  display: none;
  flex-direction: column;
  padding: 12px 20px 16px;
  border-top: 1px solid #edf2fa;
  background: #fff;
  gap: 12px;
  font-size: 15px;
  color: #333;

  span {
    cursor: pointer;
  }
}

/* Main */
.main {
  flex: 1;
  padding: 16px 0 32px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

.breadcrumb {
  font-size: 13px;
  line-height: 22px;
  color: #333;
  margin: 0 0 16px;

  .link {
    cursor: pointer;
    color: #333;

    &:hover {
      color: @blue;
    }
  }

  .sep {
    color: #d9d9d9;
    margin: 0 4px;
  }
}

.layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.col-left {
  flex: 1;
  min-width: 0;
}

.col-right {
  width: 320px;
  flex-shrink: 0;
}

.card {
  background: #fff;
  border-radius: @card-radius;
  box-shadow: @shadow;
}

/* Product card */
.product-card {
  padding: 20px;
  display: flex;
  gap: 24px;
}

.product-media {
  flex: 0 0 280px;
  max-width: 42%;
}

.info-icon-wrap {
  width: 100%;
  aspect-ratio: 1;
  max-width: 200px;
  margin: 0 auto;
  background: #1a1a1a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-icon {
  width: 56%;
  height: 56%;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.product-img {
  width: 100%;
  border-radius: 8px;
  display: block;
  object-fit: cover;
  aspect-ratio: 4 / 3;
}

.product-body {
  flex: 1;
  min-width: 0;
}

.product-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: @blue;
  line-height: 1.35;
}

.tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.tag {
  padding: 2px 12px;
  border-radius: 20px;
  font-size: 13px;
  border: 1px solid;
}

.tag-blue {
  color: @blue;
  border-color: @blue;
}

.tag-red {
  color: @warn-red;
  border-color: @warn-red;
}

.tag-gold {
  color: #d4a017;
  border-color: #d4a017;
}

.qty-row {
  margin-top: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  .label {
    color: @text-muted;
    font-size: 14px;
  }
}

.qty-stepper {
  display: flex;
  align-items: center;
  gap: 0;
}

.qty-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: @blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;

  &:disabled {
    background: #bfbfbf;
    cursor: not-allowed;
  }

  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  &:last-child {
    border-radius: 0 4px 4px 0;
  }
}

.qty-input {
  width: 72px;
  height: 32px;
  text-align: center;
  border: 1px solid #d9d9d9;
  border-left: none;
  border-right: none;
  outline: none;
  font-size: 14px;
}

.pay-row {
  margin-top: 20px;

  .pay-label {
    margin: 0 0 10px;
    font-size: 14px;
    color: #333;
  }
}

.pay-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding: 0 20px;
  background: @blue;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  cursor: default;

  .pay-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}

/* Description */
.desc-card {
  margin-top: 20px;
  overflow: hidden;
}

.desc-head {
  background: @blue;
  color: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;

  .desc-icon {
    width: 18px;
    height: 18px;
    filter: brightness(10);
  }
}

.desc-body {
  padding: 16px 20px 20px;
}

.desc-body-empty {
  min-height: 80px;
  padding: 20px;
}

.mobile-desc {
  display: none;
}

.pc-desc {
  display: block;
}

/* Order card */
.order-card {
  padding: 20px;
}

.price {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: @blue;
}

.form-title {
  margin: 20px 0 12px;
  font-size: 14px;
  color: #333;
}

.form-input {
  margin-bottom: 12px;
  height: 40px;
  border-radius: 6px;
  background: #f5f5f5 !important;
  border-color: #f0f0f0 !important;
}

.form-tip {
  margin: 4px 0 16px;
  font-size: 12px;
  color: @text-muted;
  line-height: 1.5;
}

.buy-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 6px;
  background: @blue;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background: @blue-dark;
  }

  .buy-icon {
    width: 20px;
    height: 20px;
  }
}

.contact-box {
  margin-top: 16px;
  padding: 14px;
  background: #e8f3ff;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: #333;
  line-height: 1.5;

  .contact-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
}

/* Sales */
.sales-card {
  margin-top: 16px;
  padding: 16px 20px;
}

.sales-title {
  margin: 0 0 16px;
  font-size: 14px;
  color: #888;
}

.sales-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }
}

.sales-icon-wrap {
  width: 34px;
  height: 34px;
  background: #f5f8fc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;

  img {
    width: 16px;
    height: 16px;
  }
}

.sales-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sales-label {
  font-size: 13px;
  color: #333;
}

.sales-value {
  font-size: 14px;
  color: @blue;
  font-weight: 500;
}

/* Footer */
.site-footer {
  background: #fff;
  border-top: 1px solid #edf2fa;
  padding: 14px 0;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
}

.beian {
  padding: 4px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: @blue;
  font-size: 13px;
}

.mobile-only {
  display: none;
}

.pc-only {
  display: block;
}

/* Mobile */
@media (max-width: 768px) {
  .nav-pc {
    display: none;
  }

  .nav-mobile {
    display: flex;
  }

  .mobile-menu {
    display: flex;
  }

  .breadcrumb {
    font-size: 12px;
    line-height: 20px;
  }

  .layout {
    flex-direction: column;
    gap: 16px;
  }

  .col-right {
    width: 100%;
  }

  .product-card {
    flex-direction: column;
    padding: 16px;
    gap: 16px;
  }

  .product-media {
    flex: none;
    max-width: 100%;
  }

  .info-icon-wrap {
    max-width: 160px;
  }

  .product-img {
    border-radius: 10px;
  }

  .product-title {
    font-size: 20px;
  }

  .mobile-only {
    display: flex;
  }

  .pc-only,
  .pc-desc,
  .sales-card {
    display: none !important;
  }

  .mobile-desc {
    display: block;
    margin-top: 16px;
  }

  .pay-btn {
    width: 100%;
  }

  .footer-inner {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
}
</style>
